import { SearchItem } from './module';
export const ScannerModuleId = 'Scanner' as const;

//Legacy

//V1
export interface ScannerSearchItemDataV1 {
  scannerId: string;
}

export const ScannerSearchItemVersionV1 = '1' as const;

export interface ScannerSearchItemV1 extends SearchItem<ScannerSearchItemDataV1> {
  version: typeof ScannerSearchItemVersionV1;
  moduleId: typeof ScannerModuleId;
}

export type LegacySearchModuleItem = ScannerSearchItemV1;

// Current

export type ScannerSearchItemData = ScannerSearchItemDataV1;

export const ScannerSearchItemVersion = ScannerSearchItemVersionV1;

export type ScannerSearchItem = ScannerSearchItemV1;

export const createScannerSearchItem = (scannerId: string): ScannerSearchItem => ({
  data: {
    scannerId,
  },
  id: scannerId,
  moduleId: ScannerModuleId,
  permission: { action: 'bzpro/widget/use', resource: 'scanner' },
  version: ScannerSearchItemVersion,
});

export const isLegacyScannerSearchItem = (item: SearchItem): item is LegacySearchModuleItem =>
  item.moduleId === ScannerModuleId;

export const isScannerSearchItem = (item: SearchItem): item is ScannerSearchItem =>
  item.moduleId === ScannerModuleId && item.version === ScannerSearchItemVersion;
